import React from 'react';
import { Form, Modal, Checkbox, Segment, Label, Button } from 'semantic-ui-react';
import { BaseURLDev, headers } from '../../../../../_utils/config';
import swal from 'sweetalert'

export default class ModalEdit extends React.Component {
   constructor(props){
      super(props);
      this.state = {
         data:{
               nama_bank: props.data.nama_bank,
               kode_akun: props.data.kode_akun,
               nama_akun: props.data.nama_akun,
               keterangan: props.data.keterangan,
            },

         loading:false,

      }

      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.handleKeyPress = this.handleKeyPress.bind(this)
   }

   handleKeyPress(event){
      if(event.key === '/' || event.key === '%' || event.key === "'" || event.key === '"'){
         swal("Maaf, penggunaan spesial karakter (\", ', %, /) pada isian nama atau keterangan diblock", {
            icon: "warning",
         });
      }
   }


   onSubmit(e){
      const { kode_akun, nama_akun, nama_bank, keterangan } = this.state.data;
      e.preventDefault();
      if((kode_akun===null || kode_akun==="") || (nama_akun===null || nama_akun==="") | (nama_bank===null || nama_bank==="")){
         swal("Nama Bank/Nama Aakun/Kode Akun mohon diisi",{icon:'error'})
      }else{
         this.setState({loading:true});
         e.preventDefault();
         fetch(`${BaseURLDev}/rekening_bank/${this.props.data.id}`,{
            method: 'PUT',
            headers,
            body: JSON.stringify(this.state.data)
         })
         .then(response => {
            if (!response.ok) { 
               swal("", "Update data Rekening Bank gagal", "error");
               this.setState({loading:false,error:true});
               return Promise.reject(response.statusText);
            }
            else{
               swal("Update data Rekening Bank selesai",{icon:"success"}).then(()=>{
                  window.location.href = '/b/bank';
               })
            }
         })
      }
   }

   onChange(e){
      let text = e.target.value.replace(/['/%"]/g, '')
      this.setState({data:{...this.state.data, [e.target.name]:text}});
   }

   render() {

      const {nama_akun, nama_bank,keterangan,kode_akun} = this.state.data;
      const {loading} = this.state;

      return (
      <div>
         <Modal
               open={this.props.open}
               onClose={this.props.onClose}
               closeOnEscape={false}
               closeOnRootNodeClick={false}
               size="small"
            >
               <Modal.Header>
                  Edit data Rekening Bank
               </Modal.Header>
               
               <Modal.Content scrolling>
                  <Segment padded>
                     <Label attached='top' color="violet">Form edit data Rekening Bank Penerima</Label>
                     <Form onSubmit={this.onSubmit} loading={loading}>              
                        <Form.Input value={nama_bank} onKeyPress={this.handleKeyPress} onChange={this.onChange} name="nama_bank" placeholder='Nama Bank' />               
                        <Form.Input value={nama_akun} onKeyPress={this.handleKeyPress} onChange={this.onChange} name="nama_akun" placeholder='Nama Akun Bank' />               
                        <Form.Input value={kode_akun} onKeyPress={this.handleKeyPress} onChange={this.onChange} name="kode_akun" placeholder="Kode Akun Bank"/>
                        <Form.Input value={keterangan} onKeyPress={this.handleKeyPress} onChange={this.onChange} name="keterangan" placeholder='Keterangan' />               
                        <Form.Button positive>Perbaharui</Form.Button>
                     </Form>
                  </Segment>
               </Modal.Content>
               <Modal.Actions>
                  <Button negative onClick={this.props.onClose}>Tutup</Button>                        
               </Modal.Actions>
            </Modal>                      
      </div>
      );
   }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/opd/_bank/ModalEdit.js